import { Flex } from '@primitives/Layout'
import { Text } from 'mds-web-ui'
import React from 'react'
import { InlineLink } from '../shared/InlineLink'
import { buildBreadcrumbTrail } from './buildBreadcrumbTrail'

export { buildBreadcrumbTrail }

export const Breadcrumb = ({ category, section, title, slug }) => {
  const trail = buildBreadcrumbTrail({ category, section, title, slug })

  return (
    <Flex
      as="nav"
      aria-label="Breadcrumb"
      alignItems="baseline"
      flexWrap="wrap"
      gap={1}
    >
      {trail.map((item, index) => {
        const isLast = index === trail.length - 1
        const isLink = Boolean(item.url) && !isLast

        return (
          <React.Fragment key={item.url ?? `${item.name}-${index}`}>
            {index > 0 ? (
              <Text fontSize={1} color="#585859" opacity={0.5} aria-hidden>
                {'>'}
              </Text>
            ) : null}
            {isLink ? (
              <InlineLink to={item.url} fontSize={1}>
                {item.name}
              </InlineLink>
            ) : (
              <Text
                fontSize={1}
                color="#585859"
                css={isLast ? { overflowWrap: 'anywhere' } : undefined}
              >
                {item.name}
              </Text>
            )}
          </React.Fragment>
        )
      })}
    </Flex>
  )
}
